



































































































































































































































































































































































































































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import { ViewDataFromEmailApi } from '@/api'
import { config } from '../../config'
import NotificationWithOutExit from "@/components/common/notification/NotificationWithOutExit.vue"

@Component({
    components: {
        'common-notification-notification': NotificationWithOutExit
    }
})
export default class EmailTransferSummary extends Vue {
    loading: boolean = false
    isData: boolean = true

    projectName: string = ""
    productId: string = ""
    username: string = ""
    userId: string = ""
    userCode: string = ""
    email: string = ""
    readDate: string =""
    headerTransferDate: string = ""
    companyName: string = ""

    tableDataList1: any = []
    tableDataList2: any = []
    transferDate1: any = []
    transferDate2: any = []

    async mounted() {
        await this.SetGetReportEmailTransfer()
    }

    async SetGetReportEmailTransfer() {
        this.loading = true
        this.isData = false
        const qs = this.$route.query
        const projectId = qs.pid ?? ""
        const transferDate1 = qs.date1 ?? "" as string
        const transferDate2 = qs.date2 ?? "" as string
        const companyName = qs.cname ?? "" as string
     
        this.companyName = `${companyName}`
        const tableDataList1 = await this.createTableDataList(projectId as string, transferDate1 as string);
        const tableDataList2 = await this.createTableDataList(projectId as string, transferDate2 as string);

        this.tableDataList1 = tableDataList1
        this.tableDataList2 = tableDataList2

        this.projectName = this.tableDataList1.projectName
        this.productId = this.tableDataList1.productId
        this.headerTransferDate = tableDataList1.transferDate + " และ " + tableDataList1.transferDate
        this.username = tableDataList1.username ?? tableDataList2.username
        this.email = tableDataList1.email ?? tableDataList2.email
        this.readDate = tableDataList1.readDate ?? tableDataList2.readDate
        this.userId = tableDataList1.userId ?? tableDataList2.userId
        this.userCode = tableDataList1.userCode ?? tableDataList2.userCode
        this.transferDate1 = tableDataList1.transferDate
        this.transferDate2 = tableDataList2.transferDate

        this.loading = false
        this.isData = true
    }

    async createTableDataList (projectId: string, transferDate: string) {
        const response = await ViewDataFromEmailApi.GetEmailTransfer({
            projectId: parseInt(`${projectId}`),
            transferDate: transferDate
        })
        const totalPriceOG = response.unitEmailTransferList.reduce((a: any, b: any) => a + parseFloat(b.netPrice.replace(/,/g, '')), 0)
        
        const totalPrice = Math.round(totalPriceOG).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })

        const feeTotalNetPrice = Math.round(totalPriceOG * 6.3 / 100).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })

        const feeTotalNetPriceFree = Math.round(totalPriceOG * 2 / 100).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })

        const feeTotalNetPriceCorporateTax = Math.round(totalPriceOG * 1 / 100).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })

        const feeTotalNetPriceSpecificBusinessTax = Math.round(totalPriceOG * 3.3 / 100).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })

        return {
            username: `${response.userName}`,
            email: `${response.email}`,
            readDate: `${response.readDate}`,
            userId: `${response.userId}`,
            userCode: `${response.userCode}`,
            transferDate: this.setFormatDate(transferDate),
            projectName: `${response.projectCode} ${response.projectName}`,
            productId: response.productId,
            unitEmailTransferList: response.unitEmailTransferList,
            totalNetPrice: totalPrice,
            feeTotalNetDetail: {
                totalFee: feeTotalNetPrice,
                fee: feeTotalNetPriceFree,
                corporateTax: feeTotalNetPriceCorporateTax,
                specificBusinessTax: feeTotalNetPriceSpecificBusinessTax
            }
        }
    }
    
    openLinkSiriDocument (item: any) {
        const paramsJson = {
            user_id: "1646",
            user_code: "sys_TransferPlanning",
            unit_code: item.unitCode,
            unit_id: item.unitId,
            ProjectName: item.projectName,
            Project_id: item.projectId,
            Prospect_id: item.prospectId,
            ProspectName: item.prospectName
        }
        const searchParams = new URLSearchParams(paramsJson);
        const queryString = searchParams.toString();
        const url = `${config.siriApp4Url}/siridocument/Prospect_popupAttfile_Edit.aspx?${queryString}`
        window.open(url, '_blank')
    }

    openLinkQuotation (item: any) {
        const paramsJson = {
            PJ: item.unitCode.split("-")[0],
            Unit_id: item.unitId,
            SAPCustomer_Num: item.contractNum ?? ""
        }
        const searchParams = new URLSearchParams(paramsJson);
        const queryString = searchParams.toString();
        const url = `${config.siriApp3Url}/quotation/Report/Rpt_PayTrans.aspx?${queryString}`
        window.open(url, '_blank')
    }

    setFormatDate (date: string) {
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${day}/${month}/${year}`
    }

    isCondo (productId: string) {
        return productId != '2'
    }

    notification (text: string, status: string) {
        const child = this.$refs.refNotification as any
        child.openNotification(text, status)
    }
}
